import FAQ from '../types/FAQ'

export default function FAQCard(props: { faq: FAQ }) {
	return (
		<div className='item'>
			<div className='question'><b>{props.faq.Q}</b></div>
			<div className='answer' dangerouslySetInnerHTML={{ __html: props.faq.A }} />
		</div>
	);
}